<template>
  <el-dialog
    width="30%"
    :title="!dataForm.complaintId ? '新增' : '查看'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
    >
      <el-form-item label="投诉内容" prop="content">
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入内容"
          v-model="dataForm.content"
          disabled
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="picture">
        <template>
          <img v-for="(item,index) in picture" :key="index" :src="item" style="width:150px;margin-right:10px;"/>
        </template>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button type="primary" @click="dataFormSubmit()">确定</el-button> -->
      <el-button type="primary" @click="visible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { lodgeDetail, lodgeSave, lodgeUpdate } from '../api';
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      dataForm: {
        districtId: 0,
        districtName: "",
        storeName: "",
        teamName: "",
        users: [],
        storeId: ""
      },
      picture: []
    };
  },
  mounted() {
    
  },
  methods: {
    init(id) {
      this.dataForm.complaintId = id || '';
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.complaintId) {
          lodgeDetail(this.dataForm.complaintId).then( data => {
            if (data && data.code === 0) {
              this.picture = data.sysComplaint.picture.split(',');
              this.dataForm.content = data.sysComplaint.content;
            }else {
              this.$message.error(data.msg)
            }
          });
        }
      })
      
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let data = {
            districtId: this.dataForm.districtId,
            districtName: this.dataForm.districtName,
            storeId: this.dataForm.storeId,
            storeName: this.dataForm.storeName,
            teamName: this.dataForm.teamName,
            users: this.dataForm.users,
          };
          if(this.dataForm.teamId){
            lodgeUpdate(data).then( data=> {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          }else {
            lodgeSave(data).then( data=> {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            });
          }
        }
      });
    }
  },
};
</script>
